<template>
	<div>
		<page-title-bar class="pb-1">
			<template slot="actions">
				<menu-downloads v-if="permisos.descargar"></menu-downloads>
			</template>
		</page-title-bar>
		<v-container fluid pt-0>
			<v-layout row wrap border-rad-sm overflow-hidden>
				<app-card
						colClasses="xs12"
						customClasses="mb-0"
						:fullScreen="true"
						:reloadable="true"
						:closeable="true"
						:fullBlock="true"
						:footer="false"
				>
					<data-table
							ref="tableReportesEntrega"
							v-model="dataTable"
							@resetOption="item => resetOptions(item)"
							@anular="item => openDialogCancel(item)"
							@facturar="item => openDialogFacturar(item)"
              @descargarSoporte="item => descargarSoporte(item)"
					></data-table>
				</app-card>
			</v-layout>
		</v-container>
		<confirmation-dialog
				ref="dialogCancel"
				color="error"
				heading="¿Seguro de continuar?"
				:message="`¿Está seguro de anular el reporte No. <strong>${selectedReporte ? selectedReporte.id : ''}</strong>?`"
				@onConfirm="cancelReporte"
				@onCancel="selectedReporte = null"
		>
		</confirmation-dialog>
		<detail-technologi-dialog ref="dialogInfoTechnologi" @onProcess="processingTable = false"></detail-technologi-dialog>
		<facturar-dialog
				ref="dialogFacturaReporteEntrega"
				:heading="`Registro de facturación, reporte de entrega No. <strong>${selectedReporte ? selectedReporte.id : ''}</strong>`"
		>
		</facturar-dialog>
	</div>
</template>

<script>
    var $this = null
    export default {
        components: {
			FacturarDialog: () => import('@/components/ReportesEntrega/FacturarDialog'),
            MenuDownloads: () => import('@/components/ReportesEntrega/MenuDownloads')
        },
        data: () => ({
            processingTable: false,
            selectedReporte: null,
            dataTable: {
                nameItemState: 'tableReportesEntrega',
                route: 'reporteEntregas',
                makeHeaders: [
                    {
                        text: 'ID',
                        align: 'left',
                        sortable: false,
                        visibleColumn: false,
                        value: 'direccionamiento_id'
                    },
                    {
                        text: 'Id reporte',
                        tooltip: 'Id reporte entrega',
                        align: 'left',
                        sortable: false,
                        value: 'id'
                    },
                    {
                        text: 'Tipo',
                        align: 'left',
                        sortable: false,
                        value: 'CausaNoEntrega',
                        component: {
                            render: function (createElement) {
                                return createElement(
                                    `span`,
                                    `${this.value.CausaNoEntrega ? 'No entrega' : 'Entrega'}`
                                )
                            },
                            props: ['value']
                        }
                    },
                    {
                        text: 'Prescripción',
                        align: 'left',
                        sortable: true,
                        value: 'NoPrescripcion'
                    },
					{
						text: 'Municipio Ent.',
						tooltip: 'Municipio de Entrega',
						align: 'left',
						sortable: false,
						value: 'CodMunEnt'
					},
                    {
                        text: 'ServTecEntregar',
                        tooltip: 'Servicio o tecnología a entregar',
                        align: 'center',
                        sortable: false,
                        value: 'CodSerTecAEntregar',
                        classData: 'text-xs-center',
                        component: {
                            render: function (createElement) {
                                if  (this.value.CodSerTecAEntregar) {
                                    return createElement(
                                        `a`,
                                        {
                                            domProps: {
                                                innerHTML: `${this.value.TipoTec} ${this.value.CodSerTecAEntregar}`
                                            },
                                            on: {
                                                click: () => {
                                                    $this.getDetalleTechnologi(this.value.TipoTec, this.value.CodSerTecAEntregar)
                                                }
                                            }
                                        }
                                    )
                                } else {
                                    return createElement(
                                        `span`,
                                        {
                                            domProps: {
                                                innerHTML: ``
                                            }
                                        }
                                    )
                                }
                            },
                            props: ['value']
                        }
                    },
                    {
                        text: 'ServTecEntregado',
                        tooltip: 'Servicio o tecnología entregada',
                        align: 'center',
                        sortable: false,
                        value: 'CodSerTecEntregado',
                        classData: 'text-xs-center',
                        component: {
                            render: function (createElement) {
                                if  (this.value.CodSerTecEntregado) {
                                    return createElement(
                                        `a`,
                                        {
                                            domProps: {
                                                innerHTML: `${this.value.TipoTec} ${this.value.CodSerTecEntregado}`
                                            },
                                            on: {
                                                click: () => {
                                                    $this.getDetalleTechnologi(this.value.TipoTec, this.value.CodSerTecEntregado)
                                                }
                                            }
                                        }
                                    )
                                } else {
                                    return createElement(
                                        `span`,
                                        {
                                            domProps: {
                                                innerHTML: ``
                                            }
                                        }
                                    )
                                }
                            },
                            props: ['value']
                        }
                    },
                    {
                        text: 'A entregar',
                        tooltip: 'Cantidad a entregar',
                        align: 'center',
                        sortable: false,
                        value: 'CantTotAEntregar',
                        classData: 'text-xs-center'
                    },
                    {
                        text: 'Entregada',
                        tooltip: 'Cantidad entregada',
                        align: 'center',
                        sortable: false,
                        value: 'CantTotEntregada',
                        classData: 'text-xs-center',
                        component: {
                            render: function (createElement) {
                                return createElement(
                                    `div`,
                                    {
                                        domProps: {
                                            innerHTML: `<span class="${this.value.CausaNoEntrega ? 'error--text' : ''}">${this.value.CantTotEntregada}</span>`
                                        }
                                    }
                                )
                            },
                            props: ['value']
                        }
                    },
                    {
                        text: 'Fecha entrega',
                        align: 'left',
                        sortable: false,
                        value: 'FecEntrega',
                        component: {
                            render: function (createElement) {
                                return createElement(
                                    `span`,
                                    `${this.value.FecEntrega ? this.moment(this.value.FecEntrega).format('YYYY-MM-DD HH:mm') : ''}`
                                )
                            },
                            props: ['value']
                        }
                    },
                    {
                        text: 'Valor',
                        tooltip: 'Valor entregado',
                        align: 'right',
                        sortable: false,
                        value: 'ValorEntregado',
                        classData: 'text-xs-right',
                        component: {
                            render: function (createElement) {
                                return createElement(
                                    `span`,
                                    `${this.value.ValorEntregado ? this.currency(this.value.ValorEntregado) : ''}`
                                )
                            },
                            props: ['value']
                        }
                    },
                    {
                        text: 'Paciente',
                        align: 'left',
                        sortable: false,
                        value: 'NoIDPaciente',
                        component: {
                            render: function (createElement) {
                                return createElement(
                                    `span`,
                                    `${this.value.TipoIDPaciente}${this.value.NoIDPaciente}`
                                )
                            },
                            props: ['value']
                        }
                    },
                  {
                    text: 'Usuario',
                    tooltip: 'Usuario que registra el último movimiento',
                    align: 'left',
                    sortable: false,
                    visibleColumn: false,
                    value: 'user_id',
                    component: {
                      render: function (createElement) {
                        return createElement(
                            `div`,
                            {
                              domProps: {
                                innerHTML: `
                                  <v-list-tile>
                                    <v-list-tile-content style="display: grid !important;">
                                      <v-list-tile-title class="body-2">${this.value.usuario ? this.value.usuario.name : ''}</v-list-tile-title>
                                      <v-list-tile-sub-title class="caption">${this.value.usuario ? this.value.usuario.email : ''}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                  </v-list-tile>
                                `
                              }
                            }
                        )
                      },
                      props: ['value']
                    }
                  },
                    {
                        text: 'Opciones',
                        align: 'center',
                        sortable: false,
                        actions: true,
                        singlesActions: true,
                        classData: 'text-xs-center'
                    }
                ],
                filters: []
            }
        }),
        computed: {
            permisos () {
                return this.$store.getters.getPermissionModule('reportesEntregas')
            }
        },
		created () {
            $this = this
		},
		methods: {
			openDialogFacturar (item) {
				this.selectedReporte = item
				this.$refs.dialogFacturaReporteEntrega.open(item)
			},
            getDetalleTechnologi (type, code) {
                this.processingTable = true
                this.$refs.dialogInfoTechnologi.getDetail(type, code)
            },
            cancelReporte () {
                this.$refs.dialogCancel.loading()
                this.axios.delete(`reporteEntregas/${this.selectedReporte.id}`)
                    .then(response => {
                        this.$refs.tableReportesEntrega.reloadPage()
                        this.$store.commit('snackbar', {color: 'success', message: `Se anuló el reporte No. ${this.selectedReporte.id} de forma correcta`})
                        this.$refs.dialogCancel.close()
                    }).catch(e => {
                    this.$refs.dialogCancel.loading(false)
                    this.$store.commit('snackbar', {color: 'error', message: `al tratar de anular el reporte No. ${this.selectedReporte.id}`, error: e})
                })
			},
            openDialogCancel (item) {
                this.selectedReporte = item
                this.$refs.dialogCancel.open()
			},
      async descargarSoporte (item) {
        item.loading = true
        let archivo = {
          url: `direccionamientos/soporte/${item.direccionamiento_id}`
        }
        await this.descargarArchivo(archivo)
        item.loading = false
      },
            resetOptions (item) {
                item.options = []
				        if(!item.facturado) item.options.push({event: this.permisos.facturar ? 'facturar' : '', icon: 'fas fa-cash-register', tooltip: this.permisos.facturar ? 'Facturar' : 'Sin permisos para facturar', color: this.permisos.facturar ? 'primary' : 'grey', size: 'medium'})
                item.options.push({event: this.generarSoporte ? 'descargarSoporte' : '', icon: 'zmdi zmdi-collection-pdf', tooltip: this.generarSoporte ? 'Descargar Soporte' : 'Sin permisos para descargar el soporte', color: this.generarSoporte ? 'black' : 'grey', size: 'medium'})
                item.options.push({event: this.permisos.anular ? 'anular' : '', icon: 'ti ti-trash', tooltip: this.permisos.anular ? 'Anular' : 'Sin permisos para anular', color: this.permisos.anular ? 'error' : 'grey', size: 'medium'})
                return item
            }
		}
    }
</script>
